import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { bemComponent } from '@99designs/utils/app';

const Wrapper = bemComponent('unspecified-value', 'UnspecifiedValue');
const UnspecifiedValue = ({ message }) => (
    <Wrapper>{message || <FormattedMessage id="brief_unspecified_value" />}</Wrapper>
);
UnspecifiedValue.propTypes = {
    message: PropTypes.string,
};
UnspecifiedValue.defaultProps = {
    message: '',
};
export default UnspecifiedValue;



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/unspecified-value.jsx